module.exports = __webpack_public_path__ + "static/img/5341_phase_function_Paper_PointsHejduk_Prediction.6ec4f64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5341_phase_function_Paper_PointsHejduk_Prediction.png
// module id = W0K2
// module chunks = 0